import { OrderDirection, TableDateFilter, TableFilter, TableHeader, TableInputFilter } from '@beego/ngx-table';
import { VALIDATION } from '@shared-libs/constants';
import { translate } from '@shared-libs/helpers';
import { cloneDeep } from 'lodash';

export class BeegoTableFactory {
	public static getHeaders(): Array<Array<TableHeader>> {
		return [
			[
				// 0 = PLANNED
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.ID'), null, 1),
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.TYPE'), null, 1),
				new TableHeader(
					translate('BEEGO_APPOINTMENT.TABLE.DATE'),
					['CalendarEvent', 'startsAt', OrderDirection.asc],
					3
				),
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.CUSTOMER'), null, 4),
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.CONSULTANT'), null, 3),
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.PROBLEM'), null, 2),
				new TableHeader('', null, 1),
			],
			[
				// 1 = FINISHED
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.ID'), null, 1),
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.TYPE'), null, 1),
				new TableHeader(
					translate('BEEGO_APPOINTMENT.TABLE.DATE'),
					['CalendarEvent', 'startsAt', OrderDirection.desc],
					3
				),
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.CUSTOMER'), null, 4),
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.CONSULTANT'), null, 3),
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.SCORE'), null, 2),
				new TableHeader('', null, 1),
			],
			[
				// 2 = CANCELED
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.ID'), null, 1),
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.TYPE'), null, 1),
				new TableHeader(
					translate('BEEGO_APPOINTMENT.TABLE.DATE'),
					['CalendarEvent', 'startsAt', OrderDirection.desc],
					3
				),
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.CUSTOMER'), null, 4),
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.CONSULTANT'), null, 2),
				new TableHeader(translate('BEEGO_APPOINTMENT.TABLE.REASON'), null, 3),
				new TableHeader('', null, 1),
			],
		];
	}

	public static getFilters(): Array<{ [key: string]: TableFilter }> {
		let filters: { [key: string]: TableFilter } = {
			appointmentDateFilter: new TableDateFilter({
				property: 'date',
				name: translate('BEEGO_APPOINTMENT.TABLE.DATE'),
			}),
			consultantFilter: new TableInputFilter({
				property: 'Employee.fullName',
				name: translate('FILTERS.CONSULTANT_NAME.TITLE'),
				placeholder: translate('FILTERS.CONSULTANT_NAME.PLACEHOLDER'),
			}),
			clientFilter: new TableInputFilter({
				property: 'Client.fullName',
				name: translate('FILTERS.CLIENT_NAME.TITLE'),
				placeholder: translate('FILTERS.CLIENT_NAME.PLACEHOLDER'),
			}),
			zipcodeLastnameFilter: new TableInputFilter({
				property: 'Client.ClientAddress.zipcode',
				name: translate('FILTERS.ZIPCODE.TITLE'),
				placeholder: translate('FILTERS.ZIPCODE.PLACEHOLDER'),
				validation: VALIDATION.ZIPCODE_REGEX,
			}),
		};

		return [filters, cloneDeep(filters), cloneDeep(filters)];
	}
}
